import React, { useEffect, useState } from "react";
import PatientImg from "../../../../Assets/Images/PatientImg.png";
import BaseModal from "../BaseModal/index";
import Button from "../../Buttons/Button";
import PatientName from "../Common/PatientName";
import TextArea from "../Common/TextArea";
import FlyerMessage from "../../FlyerMessage";
import "./style.css";
import { getDDMMYY } from "../../../../Helpers";
import { addRemark } from "../../../../Services";
import { usePatientContext } from "../../../../Context/PatientContext";

/**
 * Modal for Sending Message to Patient
 * @param {function} onClose - Function to handle the modal close event
 * @param {object} remarksArray - Array containing doctor remarks
 */
export const Remarks = ({
  onClose,
  remarksArray,
  setRemarksArray,
  patientId,
  physician,
  report,
  updateTimeline,
}) => {
  const [message, setMessage] = useState("");
  const [isMessageSent, setIsMessageSent] = useState(false);
  const { patientTimeline } = usePatientContext();

  // Event handler for when the user types a message
  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  // Event handler for when the user clicks the "Send" button
  const handleSend = async (event) => {
    try {
      // Replace with your actual API call
      const addRemarksResponse = await addRemark(
        physician.physician._id,
        patientId,
        { fileid: report.reportid, remarkText: message }
      );
      if (!addRemarksResponse.error) {
        // console.log("New response added");
        updateTimeline();
        // setRemarksArray([
        //   ...remarksArray,
        //   {
        //     docId: {
        //       userId: {
        //         _id: physician.physician._id,
        //         firstName: physician.physician.firstName,
        //         lastName: physician.physician.lastName,
        //       },
        //     },
        //     date: new Date(),
        //     text: message,
        //   },
        // ]);
        setRemarksArray(addRemarksResponse.data);
        setMessage("");
      }

      // After successful send, set the state to show FlyerMessage
      //   setIsMessageSent(true);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  // Event handler for when the user clicks the "Close" button on FlyerMessage
  const handleFlyerMessageClose = () => {
    onClose();
    // Reset the state to hide FlyerMessage
    setIsMessageSent(false);
  };

  useEffect(() => {}, [patientTimeline]);

  return (
    //BaseModal, PatientName, TextArea, Button are reusable components - pass respective props
    <BaseModal
      title="Remarks"
      onClose={onClose}
      showFlyerMessage={isMessageSent}
      flyerMessageText={"Message has been sent successfully!"}
      onFlyerMessageClose={handleFlyerMessageClose}
    >
      {/* <PatientName {...patientInfo} /> */}
      {remarksArray?.length > 0 && (
        <div className="remarks-container">
          {remarksArray.map((item, index) => {
            return (
              <div className="remark" key={index}>
                <div className="remark-heading">
                  <img
                    className="physician-img"
                    alt="physician_image"
                    src={PatientImg}
                  />
                  <p className="body1 body1-600 dark-grey">
                    {`${item?.docId?.userId?.firstName} ${item?.docId?.userId?.lastName}`}
                  </p>
                  <p className="body1 medium-grey">{getDDMMYY(item?.date)}</p>
                </div>
                <p className="body1 medium-grey">{item.text}</p>
              </div>
            );
          })}
        </div>
      )}
      <div className="new-remark">
        <img className="physician-img" alt="patient_image" src={PatientImg} />
        <TextArea
          textAreaType="remarks"
          placeholder="Add a comment.."
          value={message}
          onChange={handleMessageChange}
        />
        <div>
          <Button btnType="save" onClick={handleSend} />
        </div>
      </div>
    </BaseModal>
  );
};
